import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
	PROJECT_TYPE_FEATURE_KEY,
	ProjectTypeState,
	ProjectTypePartialState,
	projectTypeAdapter
} from './project-type.reducer';

// Lookup the 'ProjectType' feature state managed by NgRx
export const getProjectTypeState = createFeatureSelector<
	ProjectTypePartialState,
	ProjectTypeState
>(PROJECT_TYPE_FEATURE_KEY);

const { selectAll, selectEntities } = projectTypeAdapter.getSelectors();

export const getProjectTypeLoaded = createSelector(
	getProjectTypeState,
	(state: ProjectTypeState) => state.loaded
);

export const getProjectTypeError = createSelector(
	getProjectTypeState,
	(state: ProjectTypeState) => state.error
);

export const loadingProjectType = createSelector(
	getProjectTypeState,
	(state: ProjectTypeState) => state.loaded
);

export const getAllProjectType = createSelector(
	getProjectTypeState,
	(state: ProjectTypeState) => selectAll(state)
);

export const getProjectTypeEntities = createSelector(
	getProjectTypeState,
	(state: ProjectTypeState) => selectEntities(state)
);

export const getSelectedId = createSelector(
	getProjectTypeState,
	(state: ProjectTypeState) => state.selectedProjectTypeId
);

export const getSelected = createSelector(
	getProjectTypeEntities,
	getSelectedId,
	(entities, selectedId) => selectedId && entities[selectedId]
);
